import { useEffect, useState } from "react";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { ChipInput } from "@/components/ChipInput";
import { api } from "@/lib/api";
import { EXCLUSIVE, RATINGS, WARNINGS } from "@/lib/writing";

const sel = "h-10 w-full rounded-md bg-inset border border-line text-sm text-slate-200 px-3";

const useWorldNames = (worldId, profileId) => {
  const [s, setS] = useState({ chars: [], ships: [] });
  useEffect(() => {
    if (!worldId) return setS({ chars: [], ships: [] });
    api.get(`/worlds/${worldId}/pages`, { params: profileId ? { profile: profileId } : {} }).then((r) => setS({
      chars: r.data.filter((p) => p.category === "Characters").map((p) => p.title),
      ships: r.data.filter((p) => p.category === "Ships").map((p) => p.title),
    })).catch(() => setS({ chars: [], ships: [] }));
  }, [worldId, profileId]);
  return s;
};

const WarningPicker = ({ value, onChange }) => {
  const toggle = (k, on) => {
    if (!on) return onChange(value.filter((x) => x !== k));
    onChange(EXCLUSIVE.includes(k) ? [k] : [...value.filter((x) => !EXCLUSIVE.includes(x)), k]);
  };
  return (
    <div className="grid sm:grid-cols-2 gap-x-4 gap-y-2" data-testid="work-warnings">
      {WARNINGS.map(([k, l]) => (
        <label key={k} className="flex items-start gap-2 text-xs text-slate-300 cursor-pointer">
          <Checkbox checked={value.includes(k)} onCheckedChange={(on) => toggle(k, !!on)} className="mt-0.5" data-testid={`work-warning-${k}`} />{l}
        </label>
      ))}
    </div>
  );
};

// Rating, warnings, fandoms, characters and relationships
export const FicDetails = ({ value, set }) => {
  const names = useWorldNames(value.world_id, value.profile_id);
  return (
    <div className="space-y-4 rounded-xl border border-line p-4" data-testid="work-fic-details">
      {value.kind === "fanfiction" && <div className="space-y-1.5"><Label>Fandoms</Label>
        <ChipInput values={value.fandoms} onChange={(v) => set("fandoms", v)} placeholder="Add a fandom and press Enter" testId="work-fandom" tone="border-violet-400/30 bg-violet-500/5 text-violet-200" /></div>}
      <div className="space-y-1.5"><Label>Rating</Label>
        <select value={value.rating} onChange={(e) => set("rating", e.target.value)} className={sel} data-testid="work-rating-select">
          {RATINGS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
        </select></div>
      <div className="space-y-2"><Label>Archive warnings</Label>
        <WarningPicker value={value.warnings} onChange={(v) => set("warnings", v)} />
        <ChipInput values={value.custom_warnings} onChange={(v) => set("custom_warnings", v)} placeholder="Add your own warning" testId="work-custom-warning" tone="border-rose-400/30 bg-rose-500/5 text-rose-200" /></div>
      <div className="space-y-1.5"><Label>Characters</Label>
        <ChipInput values={value.characters} onChange={(v) => set("characters", v)} suggestions={names.chars} placeholder={names.chars.length ? "Type a name, or pick from your world" : "Add a character"} testId="work-character" /></div>
      <div className="space-y-1.5"><Label>Relationships</Label>
        <ChipInput values={value.relationships} onChange={(v) => set("relationships", v)} suggestions={names.ships} placeholder="e.g. Mira/Kael or Mira & Tobin" testId="work-relationship" tone="border-pink-400/30 bg-pink-500/5 text-pink-200" /></div>
    </div>
  );
};
